import styles from "../style";
import { motion } from "framer-motion";
import { socialMedia } from "../constants";

const Footer = () => (
  <section className={`${styles.flexCenter} ${styles.paddingY} flex-col mt-20 border-t border-slate-100`}>
    <div className="w-full flex justify-between items-center md:flex-row flex-col pt-10">
      <div className="flex flex-col mb-6 md:mb-0">
        <h3 className="text-darkBlue font-poppins font-bold text-[24px] tracking-widest uppercase">VAE</h3>
        <p className="font-poppins font-normal text-slate-500 text-[14px] mt-2 max-w-[310px]">
          Innovación y autonomía al servicio de la exploración.
        </p>
      </div>

      <div className="flex flex-col items-center md:items-end">
        <div className="flex flex-row mb-6">
          {socialMedia.map((social, index) => (
            <motion.div
              key={social.id}
              whileHover={{ y: -5, scale: 1.1 }}
              className={`w-[40px] h-[40px] bg-slate-100 rounded-full flex items-center justify-center cursor-pointer border border-slate-200 transition-colors hover:border-secondary ${
                index !== socialMedia.length - 1 ? "mr-4" : "mr-0"
              }`}
              onClick={() => window.open(social.link)}
            >
              <img
                src={social.icon}
                alt={social.id}
                className="w-[20px] h-[20px] object-contain grayscale opacity-60 hover:grayscale-0 hover:opacity-100 transition-all shadow-blue-500"
              />
            </motion.div>
          ))}
        </div>
        
        <p className="font-poppins font-normal text-center text-[14px] leading-[27px] text-slate-400">
          Copyright Ⓒ 2026 VAE Project. Todos los derechos reservados.
        </p>
      </div>
    </div>
  </section>
);

export default Footer;
